import type { OpportunityResponseDto } from '../../features/opportunities/opportunity.mapper';
import { mockQualificationMaterialChangeById } from './qualification-mock.helpers';

type MockWorkspaceFileRecord = {
  fileId: string;
  ingestionStatus: string;
};

const filesByWorkspaceId = new Map<string, MockWorkspaceFileRecord[]>();

/** Seeds a persisted workspace file for mock DELETE / rewind tests. */
export function mockSeedWorkspaceFile(
  workspaceId: string,
  fileId: string,
  ingestionStatus: string,
): void {
  const list = filesByWorkspaceId.get(workspaceId) ?? [];
  const existingIndex = list.findIndex((row) => row.fileId === fileId);
  const record: MockWorkspaceFileRecord = { fileId, ingestionStatus };
  if (existingIndex >= 0) {
    list[existingIndex] = record;
  } else {
    list.push(record);
  }
  filesByWorkspaceId.set(workspaceId, list);
}

export function mockClearWorkspaceFilesStore(): void {
  filesByWorkspaceId.clear();
}

function isIndexedIngestionStatus(ingestionStatus: string): boolean {
  return ingestionStatus.toLowerCase() === 'indexed';
}

export function mockHandleWorkspaceFilesRoute(
  method: string,
  canonical: string,
  opportunities: OpportunityResponseDto[],
): { status: number; body: unknown } | null {
  const deleteMatch = /^\/api\/opportunities\/workspaces\/([^/]+)\/files\/([^/]+)$/.exec(canonical);
  if (!deleteMatch || method !== 'DELETE') {
    return null;
  }

  const workspaceId = decodeURIComponent(deleteMatch[1]);
  const fileId = decodeURIComponent(deleteMatch[2]);
  const files = filesByWorkspaceId.get(workspaceId);
  const fileIndex = files?.findIndex((row) => row.fileId === fileId) ?? -1;
  if (!files || fileIndex < 0) {
    return { status: 404, body: null };
  }

  const [removed] = files.splice(fileIndex, 1);
  if (files.length === 0) {
    filesByWorkspaceId.delete(workspaceId);
  }

  if (isIndexedIngestionStatus(removed.ingestionStatus)) {
    const opportunity = opportunities.find((row) => row.workspaceId === workspaceId);
    if (opportunity?.id) {
      mockQualificationMaterialChangeById(opportunity.id, 'documentRemoved');
    }
  }

  return { status: 204, body: null };
}
